// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  margin: 90px 10px 10px 230px;
  width: calc(100% - 240px);
  height: 500px;
  border-radius: 5px;
}

.rtl main {
  margin: 90px 230px 30px 10px;
}

@media (max-width: 1000px) {
  main {
    margin: 90px 10px 10px 10px !important;
    width: calc(100% - 20px);
  }
}
@media (max-width: 450px) {
  main {
    margin: 80px 10px 20px 10px !important;
    width: calc(100% - 20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEE;EACE,4BAAA;AACJ;;AAEA;EACE;IACE,sCAAA;IACA,wBAAA;EACF;AACF;AACA;EACE;IACE,sCAAA;IACA,wBAAA;EACF;AACF","sourcesContent":["main {\n  margin: 90px 10px 10px 230px;\n  width: calc(100% - 240px);\n  height: 500px;\n  border-radius: 5px;\n}\n.rtl {\n  main {\n    margin: 90px 230px 30px 10px;\n  }\n}\n@media (max-width: 1000px) {\n  main {\n    margin: 90px 10px 10px 10px !important;\n    width: calc(100% - 20px);\n  }\n}\n@media (max-width: 450px) {\n  main {\n    margin: 80px 10px 20px 10px !important;\n    width: calc(100% - 20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
